import {mmcAjax} from '@/common/js/mmcModule';

export function checkOrderStatus(trade_no) {
    return mmcAjax({
        method: 'GET',
        url: `${window.APIBasePath}mmc/pay/check/isSuccess/${trade_no}`,
        crossDomain: true,
    })
}
